import { useEffect, useState } from "react";
import { parseDocxPreview } from "./docxPreview";

export function useDocxPreview(enabled: boolean, url: string | null | undefined) {
  const [content, setContent] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!enabled || !url?.trim()) {
      setContent(null);
      setLoading(false);
      setError(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(false);
    setContent(null);

    void fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch Word document");
        return res.arrayBuffer();
      })
      .then((buffer) => parseDocxPreview(buffer))
      .then((text) => {
        if (!cancelled) setContent(text);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, url]);

  return { content, loading, error };
}
